import React from "react";
import { Card, CardContent, CardHeader, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import {
  EntityHasSystemsCard,
  EntityLayout,
  EntityLinksCard,
  AboutField,
} from '@backstage/plugin-catalog';
import { useEntity } from "@backstage/plugin-catalog-react";
import { Link, MarkdownContent } from "@backstage/core-components";
import { EaPackDomainEntityV1beta1 } from "@internal/plugin-ea-pack-common";
import { UserAndTitleField } from "../UserCard";
import ListAltIcon from '@material-ui/icons/ListAlt';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import { HasProductLinesCard } from "../HasProductLinesCard";


export const DomainEntityLayout = (props: { children?: React.ReactNode, gemcheckCard?: React.ReactNode }) => {
  const entity = useEntity().entity as EaPackDomainEntityV1beta1;
  const roles = entity.spec.roles;


  const jiraProjectKey = entity.metadata.annotations?.["jira/project-key"]
  const jiraCascaded = entity.metadata.annotations?.["pandora.net/jql-incl-all-subdomains"]

  return (
    <EntityLayout parentEntityRelations={["partOf"]}>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3} alignItems="stretch">
          <Grid item md={6}>
            <Card >
              <CardHeader title="About" action={<>
                <IconButton
                  component={Link}
                  aria-label="Jira"
                  disabled={jiraProjectKey === undefined}
                  title={"Jira Dashboard"}
                  to={`https://pandoradigital.atlassian.net/browse/${encodeURIComponent(jiraProjectKey!)}`}
                >
                  <ListAltIcon />
                </IconButton>
                <IconButton
                  component={Link}
                  aria-label="Jira"
                  disabled={jiraCascaded === undefined}
                  title={"All Issues including Sub-domains"}
                  to={`https://pandoradigital.atlassian.net/issues/?jql=${encodeURIComponent(jiraCascaded!)}`}
                >
                  <ClearAllIcon />
                </IconButton>
              </>
              } />
              <Divider />
              <CardContent >
                <Grid container>
                  <Grid item xs={12}>
                    <AboutField label="Description">
                      <MarkdownContent content={entity?.metadata?.description || 'No description'} />
                    </AboutField>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6}>
            <Grid container spacing={3}>
              <Grid item md={12}>
                <Card >
                  <CardHeader title="The Team" />
                  <Divider />
                  <CardContent >
                    <Grid container>
                      <UserAndTitleField user={roles?.domainLead} title="Lead" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                      <UserAndTitleField user={roles?.deliveryLead} title="Delivery" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                      <UserAndTitleField user={roles?.enterpriseArchitect} title="Enterprise Architect" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                      <UserAndTitleField user={roles?.financeBusinessPartner} title="Finance Business Partner" onlyAvatar={false} gridSizes={{ xs: 6 }} />
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={12}>
                {props.gemcheckCard}
              </Grid>
            </Grid>
          </Grid>
          {/* <Grid item md={6}>
            <EntityLinksCard />
          </Grid> */}
          <Grid item md={12}>
            <HasProductLinesCard variant="gridItem" />
          </Grid>
          <Grid item md={12}>
            <EntityHasSystemsCard variant="gridItem" title="Products" />
          </Grid>
        </Grid >
      </EntityLayout.Route >
      {props.children}
    </EntityLayout >
  );
};
